import { render } from "./ListPage.vue?vue&type=template&id=21cb60a0&scoped=true"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=21cb60a0&scoped=true&lang=css"

import exportComponent from "/Users/macbookpro/Desktop/thecustomer/st-daara/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cb60a0"]])

export default __exports__